<p-image class="flex-shrink-0 opacity-60" imageClass="object-cover h-[90px] w-[90px] rounded-lg grayscale" src="https://a806-housingconnectapi.nyc.gov/MailTemplates/photos/28010369.png"/>
<div>
  <p class="font-medium">{{title()}}</p>
  <p class="text-sm text-muted-color">{{description()}}</p>
</div>
